<template>
  <VAppBar
    v-if="visible"
    class="shared-cart"
    max-height="35"
    height="35"
    color="#026F68"
    short
    flat
  >
    <VRow class="my-0" align="center" style="flex-wrap:nowrap;">
      <VCol cols="auto" class="mb-1 py-3 py-sm-0">
        <ExitSharedCart>
          <template #default="{ exit }">
            <SBtn link-medium color="white" data-testid="shared-exit" @click="exit">
              {{ $t('ida.btn.exit') }}
            </SBtn>
          </template>
        </ExitSharedCart>
      </VCol>
      <VCol class="text-center py-0" style="line-height:16px;">
        {{ $t('customerCart.header.currentlyShopping', {demonstratorName: cartStore.demonstratorName }) }}
      </VCol>
    </VRow>
  </VAppBar>
</template>

<script lang="ts" setup>
import { useCartStore } from '~/stores/cart'
import ExitSharedCart from '~/components/cart/ExitSharedCart.vue'
import { UserRole } from '~/types/account'

const cartStore = useCartStore()
const { isAgent, user } = useSAuthState()

// Never for agents; for a signed-in shopper only when the shared cart carries a valid
// demonstrator. An anonymous visitor always sees it. Same gate as Nuxt2.
const visible = computed(() => {
  if (!cartStore.isSharedCartMode || isAgent.value) {
    return false
  }
  return (user.value?.role ?? UserRole.Anonymous) === UserRole.Anonymous ||
    (cartStore.demonstrator?.demoId ?? 0) > 0
})
</script>

<style lang='scss' scoped>
@use '~/assets/scss/settings';
@use 'sass:map';

.shared-cart {
  color: white;
  height: 35px;
  max-height: 35px;
  // fix for rewards drawer to be below shared cart
  z-index: 3;
}
@media #{map.get(settings.$display-breakpoints, 'sm-and-down')} {
    .shared-cart :deep(.v-toolbar__content) {
      display: block;
    }
}
@media #{map.get(settings.$display-breakpoints, 'xs')} {
    .shared-cart {
      height: 60px !important;
      max-height: 60px !important;
    }
}
</style>
